import React from 'react';
import '../../RenderLegacyCusto.scss';

const ChannelTile = ({ channel }) => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={channel.urlFicha} key={channel.nombre}>
      <img
        className="velo GW_canalItem"
        title={channel.claim}
        alt={channel.nombre}
        src={`https://www.movistar.es${channel.icono}`}
      />
    </a>
  );
};

export default ChannelTile;
